import i18next from 'i18next';
import XHR from 'i18next-xhr-backend';
import MultiLoadAdapter from 'i18next-multiload-backend-adapter';
import * as packageJson from '@louis/translations/package.json';
import { initReactI18next } from "react-i18next";

export default class I18nextLoader {
    public static init(lang: string) {
        return this.translateInstance
            .use(MultiLoadAdapter)
            .use(initReactI18next)
            .init({
            backend: {
                backend: XHR,
                backendOption: {
                    //@ts-ignore
                    loadPath: TRANSLATIONS_ROOT_PATH + '/{{lng}}.json',
                    allowMultiLoading: true,
                    crossDomain: true
                }
            },
            lng: lang,
            ns: packageJson.louisTranslations.textDomains,
            fallbackLng: false,
            nsSeparator: false,
            keySeparator: false,
            react: { useSuspense: true }
        });
    }

    public static getInstance() {
        return this.translateInstance;
    }

    private static translateInstance = i18next.createInstance();
}
